import {NgModule} from '@angular/core';
import {IonicModule, NavParams} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {ClientNotesPage} from './client-notes';
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    ComponentsModule,
  ],
  declarations: [ClientNotesPage],
  providers: [
    NavParams,
  ],
})
export class ClientNotesPageModule {}
